
import { defineComponent, inject, onMounted, ref } from 'vue'

//components
import itemFile from '@/components/widgets/mixed/itemFile.vue'

import AuditoryService from "@/core/services/AuditoryService"
import { errManager } from "@/core/config/Tools";

export default defineComponent({
    props: {
        id: {
            type: Number,
            required: true,
            default: 0
        },
        target: {
            type: String,
            required: true,
            default: ""
        }
    },
    components: { itemFile },
    setup(props) {
        const loader = ref(false)
        const open_dialog_view_file = ref(false)
        const listItems = ref<any>([])
        //const listHistory = inject<any>('listHistory')

        const getListItems = async () => {
            loader.value = true
            await AuditoryService.getData({ id: props.id, target: props.target })
                .then((res) => {
                    listItems.value = res.data
                    loader.value = false
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
        }

        onMounted(()=>{
            getListItems()
        })

        return {
            loader,
            open_dialog_view_file,
            listItems,
            getListItems
        }
    }
})
